module.exports = __webpack_public_path__ + "img/barcelo-beach.97115211.jpg";